import { MembershipType } from 'types/membership'
import { OrderType } from 'types/order'
import { postApiRequest } from 'utils/fetch-helper'

export async function purchaseMembership(
    tenantId: string,
    clientEmail: string,
    clientFirstName: string,
    clientLastName: string,
    clientPhone: string,
    clientTimezone: string,
    amount: number,
    couponCode = '',
    membership_type: MembershipType,
    membership_id: string,
    paymentMethod: string | null,
    paymentMethodId: string,
    savePaymentMethod = false,
    commissionAmount = 0,
    commission = 'CUSTOM',
    soldBy?: string
) {
    savePaymentMethod =
        savePaymentMethod || localStorage.getItem('save_card') == 'true'

    if (amount == 0 && membership_type == MembershipType.Subscription) {
        paymentMethod = null
    }

    const payload = {
        amount,
        paymentMethodId,
        savePaymentMethod,
        tenantId,
        membershipClient: {
            membershipId: membership_id,
        },
        order: {
            clientEmail,
            clientFirstName,
            clientLastName,
            clientPhone,
            clientTimezone,
            tenantId,
            paymentMethod,
            paymentMethodId,
            type: OrderType.MEMBERSHIP,
            commissionAmount,
            commission,
            couponCode,
            soldBy,
        },
    }

    //@ts-ignore
    if (amount === 0) delete payload?.order?.paymentMethod

    return await postApiRequest(
        `/v1/payments/confirm-membership-payment`,
        payload
    )
}

export async function OrderMembershipWithFreeCoupon(
    clientEmail: string,
    clientFirstName: string,
    clientLastName: string,
    tenantId: string,
    membershipId: string,
    couponCode = '',
    soldBy?: string
) {
    return await postApiRequest(`/v1/orders/order-membership`, {
        amount: 0,
        tenantId,
        membershipClient: {
            membershipId,
        },
        order: {
            clientId: null,
            clientEmail,
            clientFirstName,
            clientLastName,
            tenantId,
            type: OrderType.MEMBERSHIP,
            couponCode,
            soldBy,
        },
        url: '/v1/orders/order-membership',
    })
}

export async function OrderMembershipForFree(
    clientId: string,
    tenantId: string,
    membershipId: string,
) {
    return await postApiRequest(`/v1/orders/order-membership`, {
        amount: 0,
        tenantId,
        membershipClient: {
            membershipId,
        },
        order: {
            clientId,
            tenantId,
            type: OrderType.MEMBERSHIP,
        },
        url: '/v1/orders/order-membership',
    })
}
